import { useDispatch, useSelector } from "react-redux";
import { RxCross2 } from "react-icons/rx";
import {
	closeBulkEnquiry,
	setSelectedVenues,
	clearSelectedVenues,
	setBulkEnquiryModal,
} from "../../store/features/bulkEnquirySlice";
import { useState } from "react";
import { getS3Thumb } from "../../utils/utilityFunctions";
import SecureImg from "../shared/SecureImg";
export default function BulkEnquiry() {
	const bulkEnquiry = useSelector((state) => state.bulkEnquiry);
	const {
		isBulkEnquiryOpen: isBulkEnquiry,
		selectedVenues: selectedEnquiries,
		enquiryType,
	} = bulkEnquiry;
	const dispatch = useDispatch();

	const removeEnquiry = (id) => {
		const updatedEnquiries = selectedEnquiries.filter(
			(venue) => venue._id !== id
		);
		dispatch(setSelectedVenues(updatedEnquiries));
	};
	return (
		<>
			{selectedEnquiries?.length > 0 && isBulkEnquiry && (
				<>
					{enquiryType === "venue" ? (
						<div className="fixed bottom-0 bg-white left-0 right-0 shadow-md z-50 p-4 px-6 flex items-center justify-between gap-4 overflow-x-auto">
							<div className="flex items-center gap-5 overflow-x-auto custom-scrollbar1 px-2 md:px-0">
								<span className="text-dark md:text-[16px] text-[11px]">
									Venues
								</span>
								{selectedEnquiries?.map((venue) => (
									<div
										key={venue._id}
										className="flex items-center bg-gray-100 shadow-md rounded p-2 md:min-w-60 gap-y-2 gap-x-7 ml-2 mb-1"
									>
										<SecureImg
											src={getS3Thumb(venue?.imagesAndVideos?.images[0])} fallbackSrc={venue?.imagesAndVideos?.images[0]}
											alt={venue?.name}
											className="md:h-10 md:w-10 h-6 w-6 object-cover rounded"
										/>
										<span className="md:text-sm font-medium text-xs ">
											{" "}
											{venue?.basicDetails?.venueName || "Undefined"}
										</span>
										<button
											onClick={() => removeEnquiry(venue?._id)}
											className=" text-lg font-bold focus:outline-none"
										>
											<RxCross2
												size={22}
												className="text-primary cursor-pointer"
											/>
										</button>
									</div>
								))}
							</div>
							<div className="flex justify-center items-center gap-4">
								<button
									onClick={() => dispatch(setBulkEnquiryModal(true))}
									className="bg-[#FE4747] md:w-auto w-full text-[12px] rounded-lg text-white py-2 md:px-4 px-3 lg:text-[16px] lg:font-[500]"
								>
									Send Enquiry
								</button>
								<div>
									<RxCross2
										size={22}
										className="text-primary cursor-pointer"
										onClick={() => {
											dispatch(closeBulkEnquiry());
										}}
									/>
								</div>
							</div>
						</div>
					) : (
						<div className="fixed bottom-0 left-0 right-0 bg-white shadow-md z-50 p-4 px-6 flex items-center justify-between gap-4 overflow-x-auto">
							<div className="flex items-center gap-5 overflow-x-auto custom-scrollbar1 px-2 md:px-0">
								<span className="text-dark md:text-[16px] text-[11px]">
									Venue & Stays
								</span>
								{selectedEnquiries?.map((venue) => (
									<div
										key={venue._id}
										className="flex items-center bg-gray-100 shadow-md rounded p-2 md:min-w-60 gap-y-2 gap-x-7 ml-2"
									>
										<SecureImg
											src={getS3Thumb(venue?.photoVideo?.images[0])} fallbackSrc={venue?.photoVideo?.images[0]}
											alt={venue?.name}
											className="md:h-10 md:w-10 h-6 w-6 object-cover rounded"
										/>
										<span className="md:text-sm font-medium text-xs ">
											{" "}
											{venue?.overview?.basicDetails?.hotelName || "Undefined"}
										</span>
										<button
											onClick={(e) => {
												e.stopPropagation();
												removeEnquiry(venue?._id);
											}}
											className=" text-lg font-bold focus:outline-none"
										>
											<RxCross2
												size={22}
												className="text-primary cursor-pointer"
											/>
										</button>
									</div>
								))}
							</div>
							<div>
								<div className="flex justify-center items-center gap-4">
									<button
										onClick={(e) => {
											e.stopPropagation();
											dispatch(setBulkEnquiryModal(true));
										}}
										className="bg-[#FE4747] md:w-auto w-full text-[12px] rounded-lg text-white py-2 md:px-4 px-3 lg:text-[16px] lg:font-[500]"
									>
										Send Enquiry
									</button>
									<div>
										<RxCross2
											size={22}
											className="text-primary cursor-pointer"
											onClick={(e) => {
												e.stopPropagation();
												dispatch(closeBulkEnquiry());
											}}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
				</>
			)}
		</>
	);
}
